import {Page} from "../../../component/Page";
import {Container, Table} from "react-bootstrap";
import React from "react";


export const Palette = () => {
    return (
        <Page>
            <div
                className={`ff-netto bg-dark swatch-primary text-center m-0 fs-3 w-100`}
                style={{
                    lineHeight: '5rem',
                    height: '5rem',
                    display: 'inline-block',
                    padding: '0 2rem',
                }}
            >
                {`Palette`}
            </div>
            <Container>
                <h3 className={`text-center`}>Couleurs</h3>
                <Table hover striped bordered >
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>RGB</th>
                            <th>HEX</th>
                            <th>CMJN</th>
                            <th>Aperçu</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>PANTONE 3115</td>
                        <td>50,185,200</td>
                        <td>#32B9C8</td>
                        <td>70/0/20/0</td>
                        <td style={{backgroundColor: "#32B9C8", width: "50px"}}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>PANTONE 253</td>
                        <td>160,50,140</td>
                        <td>#A0328C</td>
                        <td>45/90/0/0</td>
                        <td style={{backgroundColor: "#A0328C", width: "50px"}}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>PANTONE 432</td>
                        <td>70,80,90</td>
                        <td>#46505A</td>
                        <td>25/0/0/80</td>
                        <td style={{backgroundColor: "#46505A", width: "50px"}}>&nbsp;</td>
                    </tr>
                    </tbody>
                </Table>
            </Container>
        </Page>
    )
}